var L = /* @__PURE__ */ ((r) => (r.SMALL = "SMALL", r.BIG = "BIG", r))(L || {});
export {
  L as TextCapsulesizeType
};
